<template>
     <v-app-bar color="grey lighten-3" app flat>
      <v-container class="py-0 fill-height">
        <v-img
          :src="require('../assets/logo-wocodea.png')"
          class="my-3"
          contain
          max-height="45px"
          max-width="170px"
        />
        <v-spacer></v-spacer>
        <v-btn to="/dashboard" text>Dashboard</v-btn>
        <v-btn v-if="role !== 'marketing-user'" to="/members" text>Mitglieder</v-btn>

        <v-btn v-if="marketing_feature && role==='marketing-user'" to="/marketing" text>Produktverwaltung</v-btn>
        <v-btn v-if="marketing_feature" to="/assign" text>Produktzuweisung</v-btn>

        <v-btn text @click.native="logout">Logout</v-btn>
      </v-container>
    </v-app-bar>
</template>

<script>
export default {
  computed: {
    role() {
      return localStorage.getItem('user-role');
    },
    marketing_feature() {
      return localStorage.getItem('marketing') === "1";
    },
  },
  methods: {
      logout() {
          localStorage.clear()
          // console.log('clicked logout')
          this.$store.dispatch('auth_logout').then(() => {
              this.$router.push({name: 'login'})
          })
      }
  }

}
</script>